import { endpoints } from 'core/api/endpoints';
import { apiGet, apiPost } from 'core/api/client';
import { clearExpectedRevision } from 'core/api/revisionStore';
import { clearAdminSession, getRefreshToken, setSessionFromLogin } from 'auth/tokenStore';

export const authApi = {
  async login({ email, password }) {
    const data = await apiPost(endpoints.login, { email, password }, { skipAuth: true });
    if (data?.access_token) {
      setSessionFromLogin(data);
    }
    return data;
  },

  me(config) {
    return apiGet(endpoints.me, config);
  },

  refresh(config) {
    const refreshToken = getRefreshToken();
    return apiPost(endpoints.refresh, { refresh_token: refreshToken }, {
      skipTokenRefresh: true,
      skipAuth: true,
      ...config,
    });
  },

  async logout() {
    const refreshToken = getRefreshToken();
    const body = refreshToken ? { refresh_token: refreshToken } : {};
    try {
      await apiPost(endpoints.logout, body, { skipSessionExpire: true, skipTokenRefresh: true });
    } catch {
      // Server-side logout can return 401 when the token is already invalid.
    } finally {
      clearAdminSession();
      clearExpectedRevision();
    }
  },
};
